/* eslint max-classes-per-file: 0 */
/* eslint class-methods-use-this: 0 */

import { RegisterModule } from '@/typings/common'
import { LkUser } from '@/typings/api/User'

import {
  Actions,
  createMapper,
  Getters,
  Module,
  Mutations,
  registerModule as vuexRegisterModule,
} from 'vuex-smart-module'
import { LkUsersApi, AuthServiceApi } from '@/api/resources'
// import { StorageService } from '@/helpers/storage.service'
import { MODULE_NAME } from './utils'


type S = AuthState
type G = AuthGetters
type M = AuthMutations
type A = AuthActions

class AuthState {
  public authorized = false;

  public profile: LkUser | null = null; // = StorageService.profile.get();
}

class AuthGetters extends Getters<S> {
  public get authorized() {
    return this.state.authorized
  }

  public get profile() {
    return this.state.profile
  }

  public get profileHashSum() {
    return this.getters.profile?.hash_sum
  }
}

class AuthMutations extends Mutations<S> {
  public setAuthorized(payload: boolean) {
    this.state.authorized = payload
  }

  public setProfile(payload: LkUser) {
    this.state.profile = payload
    // StorageService.profile.set(payload)
  }

  public logout() {
    this.state.profile = null
    // StorageService.profile.remove()
  }
}

class AuthActions extends Actions<S, G, M, A> {
  private readonly authServiceApi = new AuthServiceApi();

  private readonly usersApi = new LkUsersApi();

  public async getProfile() {
    const { data } = await this.usersApi.current({}, { redirect401: false })
    if (data) this.mutations.setProfile(data)
    await this.mutations.setAuthorized(!!data)
    return this.state.profile
  }

  public loginUser(params: unknown) {
    return this.authServiceApi.login(params)
  }

  public logoutUser() {
    if (this.state.profile?.suas_user_id) {
      return this.authServiceApi.logoutAs()
    }
    return this.authServiceApi.logout()
  }

  public logout() {
    return this.mutations.logout()
  }
}

const storeModule = (
  new Module({
    namespaced: false,
    state: AuthState,
    getters: AuthGetters,
    mutations: AuthMutations,
    actions: AuthActions,
  })
)

const storeMapper = createMapper(storeModule)

export {
  storeModule as authStoreModule,
  storeMapper as authStoreMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    '', // MODULE_NAME, - когда namespaced=false, то не нужен
    storeModule,
  )

  registerModule.installed = true
}
